import { Navigate, Outlet } from 'react-router-dom';
const TutorAuth = ()=>{
    const role = JSON.parse(localStorage.getItem('user_role'))
    return role === 2 ? <Outlet/>:<Navigate to='/'/>
}
export default TutorAuth;